import { defineMessages } from "react-intl";

export const messages = defineMessages({
  media: {
    id: "/Mcvt4",
    defaultMessage: "Media",
    description: "section header",
  },
  upload: {
    id: "mGiA6q",
    defaultMessage: "Upload",
    description: "modal button upload",
  },
  uploadImages: {
    id: "9CEu8k",
    defaultMessage: "Upload Images",
    description: "modal button images upload",
  },
  uploadUrl: {
    id: "Q2UXlW",
    defaultMessage: "Upload URL",
    description: "modal button url upload",
  },
  shared: {
    id: "OBsmHE",
    defaultMessage: "Shared",
    description: "media assigned to no specific variant",
  },
  sharedTooltip: {
    id: "R6BoPt",
    defaultMessage: "Shown for the whole product (all variants)",
    description: "shared media badge tooltip",
  },
  variantCount: {
    id: "CYseS8",
    defaultMessage: "{count, plural, one {# variant} other {# variants}}",
    description: "number of variants a media is assigned to",
  },
  editAssignments: {
    id: "zAiO43",
    defaultMessage: "Edit variant assignments",
    description: "media tile action",
  },
  variantTooltip: {
    defaultMessage: "Only shown when one of these variants is selected: {variants}",
    id: "R5w0n/",
    description: "variant-specific media badge tooltip",
  },
  legend: {
    defaultMessage:
      "Shared images are shown for every variant; variant images only when that variant is selected. #N is the display order on the storefront — drag images to reorder, use the pencil to choose variants.",
    id: "QT0UcD",
    description: "explains shared vs variant media and ordering",
  },
  previewTitle: {
    defaultMessage: "Storefront preview",
    id: "zDc+Ez",
    description: "storefront gallery preview section title",
  },
  previewNoVariant: {
    defaultMessage: "No variant selected",
    id: "zDfGXD",
    description: "storefront preview option",
  },
  previewAllSummary: {
    defaultMessage:
      "With no variant selected the product page shows all {total, plural, one {# image} other {# images}}.",
    id: "/6aFlb",
    description: "storefront preview summary without variant",
  },
  previewVariantSummary: {
    defaultMessage:
      "Shows {shown} of {total} images: {shared} shared + {own} of this variant. Dimmed images above are hidden for this variant.",
    id: "dXf6Kq",
    description: "storefront preview summary for a variant",
  },
});
